import React, { useState } from "react";
import { motion } from "framer-motion";
import { cn } from "../lib/utils";

export const WobbleCard = ({
  children,
  containerClassName,
  className,
  image,
  title,
  description,
  features = []
}) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseMove = (event) => {
    const { clientX, clientY } = event;
    const rect = event.currentTarget.getBoundingClientRect();
    const x = (clientX - (rect.left + rect.width / 2)) / 20;
    const y = (clientY - (rect.top + rect.height / 2)) / 20;
    setMousePosition({ x, y });
  };

  return (
    <motion.section
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => {
        setIsHovering(false);
        setMousePosition({ x: 0, y: 0 });
      }}
      style={{
        transform: isHovering
          ? `translate3d(${mousePosition.x}px, ${mousePosition.y}px, 0) scale3d(1, 1, 1)`
          : "translate3d(0px, 0px, 0) scale3d(1, 1, 1)",
        transition: "transform 0.1s ease-out",
      }}
      className={cn(
        "mx-auto w-full relative rounded-2xl overflow-hidden min-h-[500px] bg-white",
        containerClassName
      )}>
      <div
        className="relative h-full overflow-hidden"
        style={{
          boxShadow:
            "0 10px 32px rgba(34, 42, 53, 0.12), 0 1px 1px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(34, 42, 53, 0.05), 0 4px 6px rgba(34, 42, 53, 0.08), 0 24px 108px rgba(47, 48, 55, 0.10)",
        }}>
        {/* Image Section */}
        <motion.div
          onMouseMove={handleMouseMove}
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => {
            setIsHovering(false);
            setMousePosition({ x: 0, y: 0 });
          }}
          style={{
            transform: isHovering
              ? `translate3d(${mousePosition.x}px, ${mousePosition.y}px, 0) scale3d(1, 1, 1)`
              : "translate3d(0px, 0px, 0) scale3d(1, 1, 1)",
            transition: "transform 0.1s ease-out",
          }}
          className="relative h-48 sm:h-56 md:h-64 overflow-hidden rounded-t-2xl">
          <motion.img
            src={image}
            alt={title}
            style={{
              transform: isHovering
                ? `translate3d(${-mousePosition.x}px, ${-mousePosition.y}px, 0) scale3d(1.03, 1.03, 1)`
                : "translate3d(0px, 0px, 0) scale3d(1, 1, 1)",
              transition: "transform 0.1s ease-out",
            }}
            className="w-full h-full object-cover"
          />
        </motion.div>

        {/* Content Section */}
        <div className={cn("px-4 py-6 sm:px-6 bg-white rounded-b-2xl", className)}>
          <h3 className="text-xl font-bold text-gray-900 mb-3">{title}</h3>
          {features.length > 0 ? (
            <>
              <p className="text-gray-600 mb-3">{description}</p>
              <div className="mt-3 max-h-[250px] overflow-y-auto pr-2 custom-scrollbar">
                <div className="grid grid-cols-1 gap-2">
                  {features.map((feature, index) => (
                    <div
                      key={index}
                      className="bg-red-600/90 backdrop-blur-sm rounded-md px-3 py-2 border border-red-500/50 hover:bg-red-700/90 transition-all duration-200 hover:scale-[1.02] cursor-default shadow-md"
                    >
                      <p className="text-white text-xs sm:text-sm leading-relaxed font-medium">{feature}</p>
                    </div>
                  ))}
                </div>
              </div>
            </>
          ) : (
            <div className="mt-3">
              <div className="bg-red-600/90 backdrop-blur-sm rounded-md px-3 py-2 border border-red-500/50 hover:bg-red-700/90 transition-all duration-200 hover:scale-[1.02] cursor-default shadow-md">
                <p className="text-white text-xs sm:text-sm leading-relaxed font-medium">{description}</p>
              </div>
            </div>
          )}
          {children}
        </div>
      </div>
    </motion.section>
  );
};

